import moment from 'moment'
import validate from 'validate.js'
(function() {
  validate.options = {
    fullMessages: false
  }
  validate.extend(validate.validators.datetime, {
    parse: function(value, options) {
      return +moment.utc(value);
    },
    format: function(value, options) {
      var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
      return moment.utc(value).format(format);
    }
  });

  // Rule constraint templates used to validate the form
   var rules = {
       "first_name": {
         constraints: {
           "first_name": {
	      presence: {
                  message: "required"
	      },
           }  
        }
      },
      "last_name": {
        constraints: {
           "last_name": {
	      presence: {
                  message: "required"
	      },
           }  
        }
      },
      "email": {
        constraints: {
           "email": {
	      presence: {
                  message: "required"
	      },
              email: true
           }  
        }
      },
      "company": {
        constraints: {
           "company": {
	      presence: {
                  message: "required"
	      },
           }  
        }
      },
      "phone": {
        constraints: {
           "phone": {
	      presence: {
                  message: "required"
	      },
           }  
        }
      },
      "numemployees": {
        constraints: {
           "numemployees": {
	      numericality: {
	          onlyInteger: true,
                  greaterThan: 0
	      },
	      presence: {
                  message: "required"
	      },
           }  
        }
      },
      "message": {
        constraints: {
           "message": {
	      presence: {
                  message: "required"
	      },
           }  
        }
      },
   }

  // Attach to pardot forms
  var forms = document.querySelectorAll('form.pardot'), i;

  for (i = 0; i < forms.length; ++i) {
      const form = forms[i];
      const submit = form.querySelector('.faction input.btn');
      submit.addEventListener("click", function(ev) {
        ev.preventDefault();
        handleFormSubmit(form);
      });
  }

  function handleFormSubmit(form, input) {
    // validate the form against the constraints
    var fields = form.querySelectorAll("input[name], select[name], textarea[name]"), i;
    var constraints = {};
    
    for (i = 0; i < fields.length; ++i) {
      var field_name = fields[i].name;
      var field_type = fields[i].name.split('[')[0];
      if(field_name !== 'f' && field_name !== 't' && field_name !== 'success_message') {  
        var rule = rules[field_type], this_rule = [];
        this_rule[field_name] = rule;
        constraints[field_name] = Object.fromEntries(Object.entries(rules[field_type].constraints[field_type]))
      }
    }

    var errors = validate(form, constraints);
    showErrors(form, errors || {});
    if (!errors) {
      // Process form post
      var url = form.querySelector('input[name="t"]').value;
      var formData = new FormData(form);
      var xhr = new XMLHttpRequest();
      xhr.open("POST", '/f/p.php', true);
      xhr.onreadystatechange = function() {
          if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
              showSuccess(form);
          } else if(this.status !== 200) {
	      console.log("Error",errors);
          }
      }
      xhr.send(formData);	
    }
  }

  function showErrors(form, errors) {
    var fields = form.querySelectorAll("input[name], select[name], textarea[name]"), i;
    for (i = 0; i < fields.length; ++i) {
      showErrorsForInput(fields[i], errors && errors[fields[i].name]);
    }
  }

  function showErrorsForInput(input, errors) {
    if(input.name !== 'f' && input.name !== 't' && input.name !== 'success_message') {
        var formGroup = closestParent(input.parentNode, "frow");
        var messages = formGroup.querySelector(".messages");
        if (errors) {
          formGroup.classList.add("has-error");
          for (var i = 0; i < errors.length; ++i) {
            addError(messages, errors[i]);
          }
        } else {
          formGroup.classList.add("has-success");
        }
     }
  }

  // Recusively finds the closest parent that has the specified class
  function closestParent(child, className) {
    if (!child || child == document) {
      return null;
    }
    if (child.classList.contains(className)) {
      return child;
    } else {
      return closestParent(child.parentNode, className);
    }
  }

  function resetFormGroup(formGroup) {
    formGroup.classList.remove("has-error");
    formGroup.classList.remove("has-success");
    var messages = formGroup.querySelectorAll(".help-block.error"), i;
    for (i = 0; i < messages.length; ++i) {
      messages[i].parentNode.removeChild(messages[i]);
    }
  }

  function addError(messages, error) {
    var block = document.createElement("p");
    block.classList.add("help-block");
    block.classList.add("error");
    block.innerText = error;
    messages.appendChild(block);
  }

  function showSuccess(form) {
    var success_message = form.querySelector('input[name="success_message"]').value;
    form.reset();
    var success_el = document.createElement("p");
    success_el.classList.add("help-block");
    success_el.classList.add("success");
    success_el.innerText = success_message;
    var frows  = form.querySelectorAll(".frow"), i;
    for (i = 0; i < frows.length; ++i) {
        frows[i].hidden = true;
    }
    form.querySelector('.faction').hidden = true;
    form.appendChild(success_el);
  }
})();
  
